import { lazy, StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ChakraProvider, createStandaloneToast, extendTheme } from '@chakra-ui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import App from 'App';
import { PersistGate } from 'redux-persist/integration/react';
import { queryClient } from 'test-utils/testUtils';

import { persistor, store } from './state/store';

// Only load React Query Devtools in development to keep them out of the production bundle.
const ReactQueryDevtools = process.env.NODE_ENV === 'development'
  ? lazy(() => import('@tanstack/react-query-devtools').then((m) => ({ default: m.ReactQueryDevtools })))
  : null;


const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);
const { ToastContainer } = createStandaloneToast();
const theme = extendTheme({
  components: {
    Checkbox: {
      baseStyle: {
        control: {
          borderColor: 'gray.300',
          borderWidth: '1px',
          _hover: {
            borderColor: 'blue.400',
          },
          _checked: {
            bg: 'blue.500',
            borderColor: 'blue.500',
            color: 'white',
            _hover: {
              bg: 'blue.600',
              borderColor: 'blue.600',
            },
          },
          _focus: {
            boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
          },
          _disabled: {
            borderColor: 'gray.200',
            bg: 'gray.50',
          },
        },
      },
    },
  },
});

root.render(
  <StrictMode>
    <ChakraProvider theme={theme} cssVarsRoot="body">
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
        <ToastContainer />
        {ReactQueryDevtools && (
          <Suspense fallback={null}>
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
          </Suspense>
        )}
      </QueryClientProvider>
    </ChakraProvider>
  </StrictMode>,
); 